import React, { useMemo, useState } from 'react'

import { params } from '../../../../../redux/reducers/reducer'

import PillarLegs from '../../PillarLegs';
import LeftPorchLeg from '../../PillarLegs/LeftPorchLeg';
import RightPorchLeg from '../../PillarLegs/RightPorchLeg';

const Legs = ({ overlapTrussArr, normalMap, envMap, setLeanToTrussPosArr }) => {

    const [isEqualLeftHeight, setIsEqualLeftHeight] = useState(false);
    const [leftPorchLength, setLeftPorchLength] = useState(0);
    const [leanToLength, setLeanToLength] = useState(0)

    const trimThickness = 0.2;

    const roofPitchHeight = (params.b_l_t_r_p / 12) * params.lean_p_w;
    const trimOffsetHeight = (params.p_r_p / 12) * trimThickness;

    const angle = useMemo(() => {
        const a = Math.atan((roofPitchHeight - (isEqualLeftHeight && trimOffsetHeight)) / (params.lean_p_w - (isEqualLeftHeight && trimThickness)));
        return a;
    }, [isEqualLeftHeight, roofPitchHeight, params.lean_p_w, trimOffsetHeight])

    const angleOffset = useMemo(() => {
        return (Math.atan(params.b_l_t_r_p / 12) - angle);
    }, [params.b_l_t_r_p, angle]) 

    useMemo(() => {
        if(params.p_h === roofPitchHeight + params.lean_p_h) {
            setIsEqualLeftHeight(true)
        } else {
            setIsEqualLeftHeight(false)
        }
    }, [params.p_h, params.lean_p_h, roofPitchHeight])
    

    return (
        <>
        {/* {(const_var.DistanceArr!=undefined && const_var.DistanceArr.length>0 && const_var.DistanceArr[params.p_b_t]!=undefined && const_var.DistanceArr[params.p_b_t][params.p_r_s]!=undefined) &&   */}
            <group rotation={[0, -Math.PI / 2, 0]}>
                <PillarLegs leanToKey={'left'} setLeanToTrussPosArr={setLeanToTrussPosArr} normalMap={normalMap} envMap={envMap} overlapTrussArr={overlapTrussArr} leftPorchLength={leftPorchLength} setLeanToLength={setLeanToLength} />
                {params.add_left_back_lean_porch && <LeftPorchLeg leanToKey={'left'} isAction={isEqualLeftHeight} angle={angle} trimOffsetHeight={trimOffsetHeight} angleOffset={angleOffset} overlapTrussArr={overlapTrussArr} setLeanToTrussPosArr={setLeanToTrussPosArr} setLeftPorchLength={setLeftPorchLength} leftPorchLength={leftPorchLength} normalMap={normalMap} envMap={envMap} />}
                {params.add_left_front_lean_porch && <RightPorchLeg  leanToKey={'left'} isAction={isEqualLeftHeight} angle={angle} trimOffsetHeight={trimOffsetHeight} angleOffset={angleOffset} overlapTrussArr={overlapTrussArr} setLeanToTrussPosArr={setLeanToTrussPosArr} leanToLength={leanToLength} leftPorchLength={leftPorchLength} normalMap={normalMap} envMap={envMap} />}
            </group>
        {/* } */}
        </>
    )
}

export default Legs